
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokolhapurcabs() {



    const cardData =
    {
        keyword: 'Pune to Kolhapur Cabs',
        heading: 'Platinum24 Cabs: Pune to Kolhapur Cabs',
        headingDescription: ' Platinum24 Cabs provides dependable Pune to Kolhapur Cabs, ideal for business travel, family tours, and religious visits to the famous Mahalaxmi Temple. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable journey on the Pune–Kolhapur highway with spacious seating and air-conditioned comfort. With professional chauffeurs, timely pickups, and transparent fares, we make your long-distance travel completely hassle-free. Whether you’re planning a temple darshan, exploring Panhala Fort, or enjoying Kolhapuri cuisine, Platinum24 Cabs guarantees affordable fares, reliable service, and 24/7 availability for your Pune to Kolhapur trip.',

        top: 'Top Places to Visit in Kolhapur with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Mahalaxmi Temple",
    "description": "The Mahalaxmi Temple, also known as Ambabai Temple, is the spiritual heart of Kolhapur. Built in the 7th century by the Chalukyas, it is one of the 51 Shakti Peethas. The black stone idol of Goddess Mahalaxmi is adorned with precious jewels. Pilgrims believe darshan here ensures prosperity and well-being. The temple’s intricate carvings and festive Navratri celebrations attract lakhs of devotees. It is Kolhapur’s most revered shrine."
  },
  {
    "title": "Rankala Lake",
    "description": "Rankala Lake, spread over 107 hectares, is Kolhapur’s favorite leisure spot. It is believed to be linked with Lord Shiva through mythological tales. The lakeside promenade is ideal for evening walks, horse rides, and street food stalls. Sunsets over the lake are mesmerizing. During weekends, families and couples flock here for relaxation. Rankala Lake is Kolhapur’s natural retreat for peace and recreation."
  },
  {
    "title": "Panhala Fort",
    "description": "Panhala Fort, located 20 km from Kolhapur, is the largest fort in the Deccan region. It was a stronghold of Chhatrapati Shivaji Maharaj and later Sambhaji Maharaj. The fort has grand gateways, ramparts, and sites like Andhar Bavadi and Teen Darwaza. Trekkers enjoy exploring its vast expanse with panoramic views of Sahyadri hills. Monsoon adds mist and charm to the fort. Panhala is Kolhapur’s proud heritage of Maratha valor."
  },
  {
    "title": "Jyotiba Temple",
    "description": "Jyotiba Temple, dedicated to Lord Jyotiba (a form of Lord Shiva), is located 17 km from Kolhapur on a hilltop. Pilgrims climb steps to reach the temple, where fairs and rituals are held during Chaitra Poornima. Devotees smear gulal (colored powder) across the temple complex, creating a vibrant spiritual atmosphere. The panoramic hill views are breathtaking. Jyotiba Temple is Kolhapur’s divine center of faith."
  },
  {
    "title": "New Palace & Shahu Museum",
    "description": "The New Palace, built in 1884, is a stunning example of Indo-Saracenic architecture. It was the residence of Chhatrapati Shahu Maharaj, the progressive ruler of Kolhapur. Today, it houses the Shahu Museum displaying royal artifacts, weapons, costumes, and hunting trophies. The palace’s stained-glass windows depict scenes from Shivaji Maharaj’s life. Surrounded by gardens, it is both regal and educational. The New Palace is Kolhapur’s royal heritage gem."
  },
  {
    "title": "Kopeshwar Temple, Khidrapur",
    "description": "Kopeshwar Temple, located near Kolhapur in Khidrapur, is an architectural masterpiece dedicated to Lord Shiva. Built in the 12th century, it features exquisite carvings of gods, animals, and celestial beings. The temple is unique as it houses both Shiva and Vishnu together. Pilgrims admire its spiritual energy and artistic brilliance. Festivals bring the temple alive with devotion. Kopeshwar is Kolhapur’s hidden jewel of heritage."
  },
  {
    "title": "Dajipur Wildlife Sanctuary",
    "description": "Dajipur Wildlife Sanctuary, also called the Bison Sanctuary, is 80 km from Kolhapur. It is home to Indian bison (gaur), deer, leopards, and a variety of birds. Jeep safaris take visitors deep into the forested hills. Monsoon makes the sanctuary lush with waterfalls and streams. Nature lovers and adventure seekers find it captivating. Dajipur is Kolhapur’s wild escape into nature."
  },
  {
    "title": "Bhavani Mandap",
    "description": "Bhavani Mandap is a historic palace and durbar hall built during the reign of Chhatrapati Shahu Maharaj. It once hosted royal functions and assemblies. The structure houses statues, relics, and a shrine dedicated to Goddess Tulja Bhavani. Its architecture reflects Maratha grandeur. It is located near Mahalaxmi Temple, making it a popular stop for tourists. Bhavani Mandap is Kolhapur’s blend of history and devotion."
  },
  {
    "title": "Radhanagari Dam",
    "description": "Radhanagari Dam, built on the Bhogawati River, is both a major water source and a scenic attraction. Surrounded by Western Ghats, it is popular for picnics and photography. The nearby Radhanagari Wildlife Sanctuary adds to its charm. During monsoon, the dam’s overflowing water creates breathtaking views. It is also a peaceful spot for birdwatching. Radhanagari Dam is Kolhapur’s refreshing natural getaway."
  },
  {
    "title": "Kolhapuri Cuisine & Markets",
    "description": "Kolhapur is famous for its spicy cuisine, especially Kolhapuri Misal, Tambada Rassa, Pandhara Rassa, and Kolhapuri Mutton. Local markets like Shivaji Market and Gandhi Chowk buzz with life. Shoppers buy Kolhapuri chappals, jaggery, and traditional jewelry. Food lovers enjoy authentic thalis and snacks across eateries. The mix of flavors, culture, and shopping makes it vibrant. Kolhapuri cuisine and markets are the city’s cultural heartbeat."
  }
],


  "services": [
    {
      "name": "Pune to Kolhapur Taxi Service",
      "description": "Travel comfortably and conveniently from Pune to Kolhapur with our reliable taxi service. Whether it's for business, leisure, or pilgrimage, our well-maintained vehicles and professional drivers ensure a safe and pleasant journey. Enjoy door-to-door service with flexible scheduling to match your itinerary."
    },
    {
      "name": "Kolhapur Cab from Pune",
      "description": "Book a cab from Pune to Kolhapur to experience hassle-free travel across this beautiful route. Our cabs offer spacious interiors, air-conditioning, and experienced chauffeurs who know the best routes to get you there quickly and safely. Ideal for solo travelers, families, and groups."
    },
    {
      "name": "Pune Kolhapur Taxi Booking",
      "description": "Easily book your taxi from Pune to Kolhapur through our seamless online platform or via phone. Choose from a variety of vehicle types depending on your needs and budget. Receive instant booking confirmations and enjoy timely pickups and drop-offs."
    },
    {
      "name": "Taxi Service Pune to Kolhapur",
      "description": "Our taxi service from Pune to Kolhapur is designed to offer maximum comfort and flexibility. Whether you want a one-way trip or a round trip, day hire or overnight journey, we provide customizable options to suit your travel plans."
    },
    {
      "name": "Kolhapur Cab Rental Pune",
      "description": "Rent a cab from Pune to Kolhapur for day trips, weekend getaways, or extended visits. Our rental service comes with a dedicated driver, ensuring you can relax and enjoy the scenic drive without worrying about directions or parking."
    },
    {
      "name": "Pune to Kolhapur Taxi Fare",
      "description": "Get transparent and competitive taxi fare quotes for your Pune to Kolhapur journey. Our fare structure includes distance, tolls, taxes, and driver allowances with no hidden charges, helping you plan your travel budget effectively."
    },
    {
      "name": "Kolhapur Private Taxi Pune",
      "description": "Opt for our Kolhapur private taxi service from Pune to enjoy personalized travel at your own pace. Our private taxis ensure exclusivity, privacy, and flexibility, perfect for family trips, corporate travel, or special occasions."
    },
    {
      "name": "Kolhapur Cab Packages Pune",
      "description": "Choose from various Kolhapur cab packages available for Pune travelers, including sightseeing tours, pilgrimage trips, and weekend getaways. Our packages are competitively priced and include all necessary amenities for a comfortable journey."
    },
    {
      "name": "Pune to Kolhapur One Way Cab",
      "description": "Our one-way cab service from Pune to Kolhapur is ideal for travelers who need a one-directional trip without the hassle of return logistics. Enjoy convenient, cost-effective travel with reliable vehicles and professional drivers."
    },
    {
      "name": "Taxi Charges Pune to Kolhapur",
      "description": "Understand the detailed taxi charges for your trip from Pune to Kolhapur, including per kilometer rates, waiting time, toll fees, and any other applicable costs. Our transparent pricing ensures no surprises at the end of your journey."
    },
    {
      "name": "Pune to Kolhapur Taxi Hire",
      "description": "Hire a taxi from Pune to Kolhapur for flexible durations, whether for a single trip or multiple days. Our service provides freedom to explore Kolhapur and surrounding areas comfortably with a dedicated driver at your service."
    },
    {
      "name": "Kolhapur Weekend Trip Cab Pune",
      "description": "Plan your perfect weekend getaway from Pune to Kolhapur with our special weekend trip cab service. Enjoy scenic drives, explore local attractions, and relax knowing your transport is sorted with our affordable and dependable cabs."
    },
    {
      "name": "Pune Kolhapur Outstation Taxi",
      "description": "Our outstation taxi service from Pune to Kolhapur caters to long-distance travelers seeking comfort and convenience. We provide timely pickups, clean vehicles, and courteous drivers to make your journey enjoyable."
    },
    {
      "name": "Kolhapur Taxi with Driver Pune",
      "description": "Travel from Pune to Kolhapur with an experienced driver who prioritizes your safety and comfort. Our drivers are well-trained, familiar with routes, and committed to providing a pleasant travel experience."
    },
    {
      "name": "Taxi Service Pune to Kolhapur",
      "description": "Reliable and affordable taxi service from Pune to Kolhapur, perfect for all kinds of travel needs. Book with us for a smooth, stress-free journey with excellent customer support and quality vehicles."
    }
  ],
  "tableData": [
    ["Pune to Kolhapur Taxi Service", "Kolhapur Cab from Pune"],
    ["Pune Kolhapur Taxi Booking", "Taxi Service Pune to Kolhapur"],
    ["Kolhapur Cab Rental Pune", "Pune to Kolhapur Taxi Fare"],
    ["Kolhapur Private Taxi Pune", "Kolhapur Cab Packages Pune"],
    ["Pune to Kolhapur One Way Cab", "Taxi Charges Pune to Kolhapur"],
    ["Pune to Kolhapur Taxi Hire", "Kolhapur Weekend Trip Cab Pune"],
    ["Pune Kolhapur Outstation Taxi", "Kolhapur Taxi with Driver Pune"],
    ["Taxi Service Pune to Kolhapur", "—"]
  ],


         "whychoose": [
    {
      "WhyChooseheading": "Reliable Pune to Kolhapur Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs offers safe and comfortable taxi services from Pune to Kolhapur for a hassle-free journey."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with the Route",
      "WhyChoosedescription": "Our skilled drivers know the Pune-Kolhapur route well to ensure a smooth and timely trip."
    },
    {
      "WhyChooseheading": "Clean and Well-Maintained Vehicles",
      "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs equipped for your comfort on long-distance journeys."
    },
    {
      "WhyChooseheading": "Flexible One-Way and Round Trip Booking Options",
      "WhyChoosedescription": "Choose packages that suit your travel plans with convenient booking options."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing inclusive of fuel, tolls, and driver allowances for a worry-free experience."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Easy Booking",
      "WhyChoosedescription": "Book your Pune to Kolhapur cab anytime with assistance from our dedicated support team."
    },
    {
      "WhyChooseheading": "Ideal for Family Trips, Pilgrimage, and Corporate Travel",
      "WhyChoosedescription": "Perfect for all kinds of travelers heading to Kolhapur from Pune."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Group Size",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers as per your comfort and luggage needs."
    }
  ]

























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Kolhapur?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for travel between Pune and Kolhapur.',
    },
    {
        question: 'How can I book a Pune to Kolhapur cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Kolhapur cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Kolhapur trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Kolhapur?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Pune to Kolhapur route.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Kolhapur?',
        answer: 'Absolutely! We provide round-trip cab services with flexible scheduling to accommodate your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Kolhapur cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Kolhapur rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Kolhapur route.',
    },
    {
        question: 'Are safety measures in place for Pune to Kolhapur cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Kolhapur travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Kolhapur?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Kolhapur routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ajay Kulkarni',
        feedback: 'The Pune to Kolhapur cab service was smooth and comfortable. The driver was punctual and professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Patil',
        feedback: 'I had a great experience traveling from Pune to Kolhapur with Platinum24 Cabs. Highly recommend their services!',
        rating: 5,
    },
];


























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const puneToKolhapurSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable Pune to Kolhapur taxi service offering affordable cab rentals, private taxis, outstation trips, and taxi packages with driver.",
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "City",
      "name": "Kolhapur"
    }
  ],
  "serviceType": [
    "Pune to Kolhapur Taxi Service",
    "Kolhapur Cab from Pune",
    "Pune Kolhapur Taxi Booking",
    "Taxi Service Pune to Kolhapur",
    "Kolhapur Cab Rental Pune",
    "Pune to Kolhapur Taxi Fare",
    "Kolhapur Private Taxi Pune",
    "Kolhapur Cab Packages Pune",
    "Pune to Kolhapur One Way Cab",
    "Taxi Charges Pune to Kolhapur",
    "Pune to Kolhapur Taxi Hire",
    "Kolhapur Weekend Trip Cab Pune",
    "Pune Kolhapur Outstation Taxi",
    "Kolhapur Taxi with Driver Pune",
    "Taxi Service Pune to Kolhapur"
  ],
  "telephone": "+91-XXXXXXXXXX"
};






    return (
        <div>

<Helmet>
  <title>Pune to Kolhapur Cabs | Taxi Service from Pune to Kolhapur</title>
  <meta
    name="description"
    content="Reliable Pune to Kolhapur taxi service offering affordable cab rentals, private taxis, outstation trips, and taxi packages with driver."
  />
  <meta
    name="keywords"
    content="Pune to Kolhapur Taxi Service, Kolhapur Cab from Pune, Pune Kolhapur Taxi Booking, Taxi Service Pune to Kolhapur, Kolhapur Cab Rental Pune, Pune to Kolhapur Taxi Fare, Kolhapur Private Taxi Pune, Kolhapur Cab Packages Pune, Pune to Kolhapur One Way Cab, Taxi Charges Pune to Kolhapur, Pune to Kolhapur Taxi Hire, Kolhapur Weekend Trip Cab Pune, Pune Kolhapur Outstation Taxi, Kolhapur Taxi with Driver Pune, Taxi Service Pune to Kolhapur"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToKolhapurSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/65.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetokolhapurcabs;